var map = {
	"./music-instructions.json": 4421,
	"./music-library-intro2024.json": 4422,
	"./music-library-launch2024.json": 4423,
	"./music-progression.json": 4424,
	"./startSourcesAdvanced.json": 4425,
	"./startSourcesSimple.json": 4426,
	"./startSourcesSimple2.json": 4427,
	"./startSourcesTracks.json": 4428
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4156;